import { render, staticRenderFns } from "./DoKoDialogTisch.vue?vue&type=template&id=9febe858&scoped=true&"
import script from "./DoKoDialogTisch.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogTisch.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogTisch.vue?vue&type=style&index=0&id=9febe858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9febe858",
  null
  
)

export default component.exports